/**
 * @Description 文件功能说明：账户 table 组件
 * @Author
 * @Time 2021/6/4
 **/
/* HTML */
<template>
	<div class="table-item-box" style="padding: 10px;">
		<section style="height: 100%;">
			<!-- 表格 -->
			<el-table :data="record" ref="multipleTable" @sort-change="changeSort" stripe style="width: 100%;margin-bottom: 10px;height: calc(100% - 90px);" :class="{'table': true, 'no-pagination': false}">
				<el-table-column prop="id_card" label="编号" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.idCard">{{scope.row.idCard}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_name" label="姓名" min-width="120px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template slot-scope="scope">
						<i v-if="scope.row.sex=='1'" class="el-icon-male"></i>
						<i v-else-if="scope.row.sex=='2'" class="el-icon-female"></i>
						<span style="white-space: nowrap;" :title="scope.row.userName">{{scope.row.userName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机号" min-width="150px">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.phone">{{scope.row.phone}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tag_id" label="绑定标签" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.tagId">{{scope.row.tagId}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="visit_timestamp" label="绑定时间" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.bindingTimeStr">{{scope.row.bindingTimeStr}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="leave_timestamp" label="解绑时间" min-width="160px" :sortable="filters.sortable" :sort-orders="filters.sortOrders">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.unBoundTimeStr">{{scope.row.unBoundTimeStr}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remarks" label="备注" min-width="160px">
					<template slot-scope="scope">
						<span style="white-space: nowrap;" :title="scope.row.remarks">{{scope.row.remarks}}</span>
					</template>
				</el-table-column>
			</el-table>

			<!--分页工具条-->
			<Pagination :currentPage="pagination.currentPage" :total="pagination.total" :pageSize="pagination.limit" @handleSizeChangeSub="handleSizeChangeSub" @handleCurrentChangeSub="handleCurrentChangeSub" />

			<!--查询工具条-->
			<el-col style="text-align: left;">
				<el-form :inline="true" :model="filters" ref="filters" style="float: left;">
					<el-form-item prop="keywords">查询条件：</el-form-item>
					<el-form-item prop="duration" class="item-cnt-lhfs-0">
						<template slot-scope="scope">
							<el-date-picker :picker-options="filters.pickerOptions" v-model="filters.duration" type="datetimerange" range-separator="—" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间">
							</el-date-picker>
						</template>
					</el-form-item>
					<el-form-item prop="keywords">
						<el-input v-model="filters.keywords" placeholder="请输入编号/姓名" clearable @keyup.enter.native="researchRecord">
							<i slot="suffix" class="el-input__icon el-icon-search" @click="researchRecord"></i>
						</el-input>
					</el-form-item>
					<el-form-item v-if="false" style="position: absolute;top: 9px;right: 20px;margin: 0;z-index: 3;">
						<el-button icon="el-icon-download" type="primary" size="mini" trigger="click" @click="exportData">数据导出</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 导出数据 -->
			<el-table :data="exportDatas" id="out-table" style="display: none;">
				<el-table-column prop="idCard" label="编号">
					<template slot-scope="scope">
						{{scope.row.idCard}}
					</template>
				</el-table-column>
				<el-table-column prop="userName" label="姓名">
					<template slot-scope="scope">
						{{scope.row.userName}}
					</template>
				</el-table-column>
				<el-table-column prop="sex" label="性别">
					<template slot-scope="scope">
						{{scope.row.sex}}
					</template>
				</el-table-column>
				<!--                <el-table-column prop="duty" label="职务">-->
				<!--                    <template slot-scope="scope">-->
				<!--                        {{scope.row.duty}}-->
				<!--                    </template>-->
				<!--                </el-table-column>-->
				<el-table-column prop="phone" label="手机号">
					<template slot-scope="scope">
						{{scope.row.phone}}
					</template>
				</el-table-column>
				<el-table-column prop="tagId" label="绑定标签">
					<template slot-scope="scope">
						{{scope.row.tagId}}
					</template>
				</el-table-column>
				<el-table-column prop="bindingTimeStr" label="绑定时间">
					<template slot-scope="scope">
						{{scope.row.bindingTimeStr}}
					</template>
				</el-table-column>
				<el-table-column prop="unBoundTimeStr" label="解绑时间">
					<template slot-scope="scope">
						{{scope.row.unBoundTimeStr}}
					</template>
				</el-table-column>
				<el-table-column prop="remarks" label="备注">
					<template slot-scope="scope">
						{{scope.row.remarks}}
					</template>
				</el-table-column>
			</el-table>

		</section>
	</div>
</template>

/* JS */
<script>
	// API 人员
	import ApiUser from "@/request/api-user";
	// API 历史记录
	import ApiRecord from "@/request/api-record";
	// 组件 公共方法
	import GlobalFun from '@/global/global-function';
	// 组件 分页
	import Pagination from '@/components/Pagination';
	// 组件 树结构
	import TreeSelect from '@/components/TreeSingleSelect';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 2021/6/4
		 */
		name: "UserBindingTable",
		/**
		 * @Des 组件引用
		 * @Auth
		 * @Date 2021/6/4
		 */
		components: {
			// 分页组件
			Pagination,
			TreeSelect
		},
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 2021/6/4
		 */
		data() {
			return {
				/**
				 * @Des 分页数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 20,
					currentPage: 1
				},
				/**
				 * @Des 查询数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				filters: {
					typeId: '',
					groupId: '',
					keywords: '',
					// 开始时间 - 结束时间
					duration: '',
					// 隐藏的时间
					pickerOptions: {
						disabledDate(v) {
							return v.getTime() > new Date().getTime()
						}
					},
					orderBy: {
						'visit_timestamp': 'desc'
					},
					sortOrders: [
						"ascending",
						"descending"
					],
					sortable: 'custom'
				},
				// 用户组信息
				userGroups: [],
				// 记录信息集合
				record: [],
				/**
				 * @Des 用户组树数据
				 * @Auth
				 * @Date 2021/6/4
				 */
				groupSelectTree: {
					placeholder: '请选择人员组',
					keywordFilter: false,
					showBox: false,
					childBox: false,
					parentBox: false,
				},
				exportDatas: [],
				/**
				 * @Des 规则属性
				 * @Auth
				 * @Date  2021/7/29
				 */
				rules: {
					duration: [{
						validator: (rule, value, callback) => {
							// 校验时间
							if(this.$checkEmpty(value)) {
								new callback(new Error('请选择开始时间与结束时间'));
							} else if(this.$checkEmpty(value[0])) {
								new callback(new Error('请选择开始时间'));
							} else if(this.$checkEmpty(value[1])) {
								new callback(new Error('请选择结束时间'));
							} else if(value[0] >= value[1]) {
								new callback(new Error('结束时间须晚于开始时间'));
							} else {
								callback()
							}
						},
					}],
				}
			}
		},
		computed: {},
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 2021/6/4
		 */
		watch: {
			/**
			 * @Des 分页监听
			 * @Auth
			 * @Date 2021/6/4
			 */
			pagination: {
				handler(newVal, oldVal) {
					this.searchRecord();
				},
				immediate: true,
				deep: true,
			}
		},
		/**
		 * @Des 初始化加载
		 * @Auth
		 * @Date 2021/6/4
		 */
		mounted() {
			// 查询记录信息
			this.searchRecord();
		},
		created() {
			// 查询用户组
			this.searchUserGroup();
		},
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 2021/6/4
		 */
		methods: {
			/**
			 * @Des 查询用户组
			 * @Auth
			 * @Date 2021/6/4
			 */
			searchUserGroup() {
				this.$request.postJsonRequest(ApiUser.searchUserGroupApi, {
					projectId: this.$store.state.currentProjectId
				}).then(result => {
					this.userGroups = [];
					if(result.code == 0) {
						this.userGroups = GlobalFun.dataToTree(Object.assign([], result.data), {
							id: 'id',
							pid: 'parentId',
							children: 'children',
							label: 'name',
						});
					}
				}).catch(error => {
					console.error('查询人员组异常', ApiUser.searchUserGroupApi, error);
				})
			},

			/**
			 * 重新搜索
			 * */
			researchRecord() {
				this.pagination.total = 0;
				this.pagination.startNum = 0;
				this.pagination.currentPage = 1;
				this.searchRecord();
			},

			/**
			 * @Des 查询绑定记录
			 * @Auth
			 * @Date 2021/6/4
			 */
			searchRecord() {
				let startDate = '';
				let endDate = '';
				if(this.filters.duration != null && this.filters.duration.length > 1) {
					startDate = new Date(this.filters.duration[0]).getTime();
					endDate = new Date(this.filters.duration[1]).getTime();
				}
				this.$request.postJsonRequest(ApiRecord.searchUserRecord, {
					typeId: this.filters.typeId == '' ? null : this.filters.typeId,
					groupId: this.filters.groupId == '' ? null : this.filters.groupId,
					keywords: this.filters.keywords,
					startDate: startDate,
					endDate: endDate,
					orderBy: this.filters.orderBy,
					projectId: this.$store.state.currentProjectId,
					total: this.pagination.total,
					startNum: this.pagination.startNum,
					limit: this.pagination.limit
				}).then(result => {
					// console.log(result)
					// console.log(this.filters.orderBy)
					this.pagination.total = result.total;
					if(this.pagination.total > 0) {
						result.rows.forEach((row, index) => {
							row.bindingTimeStr = row.bindingTime ? this.$moment(row.bindingTime).format('YYYY-MM-DD HH:mm:ss') : '';
							row.unBoundTimeStr = row.unBoundTime ? this.$moment(row.unBoundTime).format('YYYY-MM-DD HH:mm:ss') : '';
						})
					}
					this.record = result.rows;

					// console.log(this.record[0].tagId);
				}).catch(error => {
					console.error('查询人员列表异常', ApiRecord.searchUserRecord, error);
				})
			},

			/**
			 * @Des 选择值改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			setSelectVal(val) {
				if(val && val.id) {
					if(val.parentId == 0) {
						this.filters.typeId = val.id.replace("T", "");
						this.filters.groupId = '';
					} else {
						// this.filters.typeId = val.parentId.replace("T","");
						this.filters.groupId = val.id;
					}
					this.$refs['treeSelect'].setSelectVal(val);
				} else {
					this.filters.typeId = '';
					this.filters.groupId = '';
					this.$refs['treeSelect'].setSelectVal();
				}
				this.searchRecord();
			},

			/**
			 * 导出数据
			 * */
			exportData() {
				if(this.locked) return false;
				this.locked = true;
				if((this.filters.startDate == '' && this.filters.endDate != '') ||
					(this.filters.startDate != '' && this.filters.endDate == '')) {
					this.filters.startDate = '';
					this.filters.endDate = '';
				}
				this.$request.postJsonRequest(ApiRecord.exportUserRecord, {
					typeId: this.filters.typeId == '' ? null : this.filters.typeId,
					groupId: this.filters.groupId == '' ? null : this.filters.groupId,
					keywords: this.filters.keywords,
					startDate: this.filters.startDate,
					endDate: this.filters.endDate,
					orderBy: this.filters.orderBy,
					projectId: this.$store.state.currentProjectId,
				}).then(result => {
					this.exportDatas = [];
					if(result.total > 0) {
						result.rows.forEach((row, index) => {
							row.bindingTimeStr = row.bindingTime ? this.$moment(row.bindingTime).format('YYYY-MM-DD HH:mm:ss') : '';
							row.unBoundTimeStr = row.unBoundTime ? this.$moment(row.unBoundTime).format('YYYY-MM-DD HH:mm:ss') : '';
							this.exportDatas.push(row);
						})
					}
					this.$nextTick(() => {
						GlobalFun.exportExcel(document.querySelector("#out-table"), '人员绑定信息.xlsx');
						this.locked = false;
					});
				}).catch(error => {
					this.locked = false;
					console.error('导出人员列表异常', ApiRecord.exportUserRecord, error);
				})
			},

			/**
			 * @Des 当前页数据改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			handleCurrentChangeSub(val) {
				this.pagination.currentPage = val;
				this.pagination.startNum = this.pagination.limit * (val - 1);
			},
			/**
			 * @Des 页长度改变
			 * @Auth
			 * @Date 2021/6/4
			 */
			handleSizeChangeSub(val) {
				this.pagination.limit = val;
				this.pagination.currentPage = 1;
				this.pagination.startNum = 0;
			},
			/**
			 * 改变排序
			 * */
			changeSort(data) {
				let prop = data.prop;
				let order = data.order;
				if(order == null) {
					order = this.filters.orderBy[prop];
				} else {
					order = order.replace("ending", "");
				}
				if(order == null) {
					this.filters.orderBy["visit_timestamp"] = "desc";
				} else {
					this.filters.orderBy = {};
					this.filters.orderBy[prop] = order;
				}
				// console.log(this.filters.orderBy)
				this.researchRecord();
			},
		},
	}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 240px;
	}
</style>


// WEBPACK FOOTER //
// src/components_pages/Record/UserBindingTable.vue